const ParagraphSkeleton = () => {
  return (
    <div role='status' className='w-full space-y-2.5 animate-pulse mb-8'>
      <div className='flex items-center w-full'>
        <div className='h-2.5 bg-gray-200 rounded-full dark:bg-gray-400 w-32'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-24'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
      </div>
      <div className='flex items-center w-full max-w-[90%]'>
        <div className='h-2.5 bg-gray-200 rounded-full dark:bg-gray-400 w-full'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-24'></div>
      </div>
      <div className='flex items-center w-full max-w-[95%]'>
        <div className='h-2.5 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
        <div className='h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-400 w-80'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
      </div>
      <div className='flex items-center w-full'>
        <div className='h-2.5 bg-gray-200 rounded-full dark:bg-gray-400 w-full'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-24'></div>
      </div>
      <div className='flex items-center w-full pr-10'>
        <div className='h-2.5 bg-gray-300 rounded-full dark:bg-gray-300 w-32'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-24'></div>
        <div className='h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-400 w-full'></div>
      </div>
      <div className='flex items-center w-full pr-40'>
        <div className='h-2.5 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
        <div className='h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-400 w-80'></div>
        <div className='h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-300 w-full'></div>
      </div>
      <span className='sr-only'>Loading...</span>
    </div>
  );
};

export default ParagraphSkeleton;
